/**
 * Client-only bootstrap: initializes Firebase App Check after the app is created.
 * Import app from firebaseConfig and initAppCheck from appCheck only here so
 * app-check is never loaded on the server.
 */
import { useEffect } from 'react';
import app from '../../firebaseConfig.js';
import { initAppCheck } from '@/lib/firebase/appCheck';

export default function ClientFirebaseBootstrap() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    initAppCheck(app);
  }, []);
  return null;
}
